import { MyResponse, requestMiddleware } from './request';

export async function getAllCountries(): Promise<MyResponse> {
  return requestMiddleware({
    url: '/api/utility/countries',
    method: 'GET',
  });
}

export async function getLanguageOptions(): Promise<MyResponse> {
  return requestMiddleware({
    url: '/api/utility/languages',
    method: 'GET',
  });
}

export async function getApiVersion(): Promise<MyResponse> {
  return requestMiddleware({
    url: '/api/utility/version',
    method: 'GET',
  });
}

export async function getVesselGPSSources(vesselId: string): Promise<MyResponse> {
  return requestMiddleware({
    url: `/api/vessel/location/${vesselId}/persistedSources`,
    method: 'GET',
  });
}
export async function postSelectedGPSSources(
  vesselId: string,
  uids: string[]
): Promise<MyResponse> {
  return requestMiddleware({
    url: `/api/vessel/location/${vesselId}/enableSources`,
    method: 'POST',
    data: { uids },
  });
}

export async function getEnabledClientGPSSources(vesselId: string): Promise<MyResponse> {
  return requestMiddleware({
    url: `/api/vessel/location/${vesselId}/enabledSources`,
    method: 'GET',
  });
}
